import { render, staticRenderFns } from "./customQuestion.vue?vue&type=template&id=734dbf17"
import script from "./customQuestion.vue?vue&type=script&lang=js"
export * from "./customQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports